/**
 * @author tomekbuszewski & jakubmaslon
 * @since 2019-8-13
 */

import * as React from "react";
import { useSelector } from "react-redux";

import { LoadingIndicator as LoadingIndicatorAtom } from "@ui/Atoms";

import { getLoadingState } from "@app/redux/loading/loading.selectors";

const LoadingIndicator = () => {
  const show: boolean = useSelector(getLoadingState);

  return <LoadingIndicatorAtom show={show} />;
};

export { LoadingIndicator };

LoadingIndicator.displayName = "LoadingIndicator";
